import { findDOMNode, useRef, useState } from '@wordpress/element';
import ReactPlayer from 'react-player';
import screenfull from 'screenfull';
import BlockPlayerControls from './controls';

export default function BlockPlayer({ attributes }) {
    const { radius, devurl, downloadcontrols, fullscreencontrols, volumecontrols, mutecontrols, progresscontrols, forwardcontrols, rewindcontrols, restartcontrols, playcontrols, bigplayctr, pipcontrols, width, height, poster, url, pip, playing, controls, light, volume, muted, played, loaded, duration, playbackRate, loop, bigplayHide } = attributes

    const format = (seconds) => {
        if (isNaN(seconds)) {
          return `00:00`;
        }
        const date = new Date(seconds * 1000);
        const hh = date.getUTCHours();
        const mm = date.getUTCMinutes();
        const ss = date.getUTCSeconds().toString().padStart(2, "0");
        if (hh) {
          return `${hh}:${mm.toString().padStart(2, "0")}:${ss}`;
        }
        return `${mm}:${ss}`;
    };

    const [ initialBigplayHide, setInitialBigplayHide ] = useState( bigplayHide );
    const [ initialPlaying, setInitialPlaying ] = useState( playing );

    const BlockPlayerPlayPause = (playingEvent) => {
        setInitialPlaying(!initialPlaying)
        setInitialBigplayHide(!initialBigplayHide)
    }

    const BigplayctrHide = (e) => {
        setInitialBigplayHide(!initialBigplayHide)
        setInitialPlaying(!initialPlaying)
    }

    const [ initialMute, setInitialMute ] = useState( muted );
    const BlockPlayerMute = (muteEvent) => {
        setInitialMute(!initialMute)
    }

    
    const [ initialVolume, setInitialVolume ] = useState( volume );
    const onChangeVolume = (newVal) => {
        setInitialVolume(
            parseFloat(newVal / 100)
        )
        setInitialMute(
            newVal === 0 ? true : false
        )
    }
    const onChangeCommittedVolume = (newVal) => {
        setInitialVolume(
            parseFloat(newVal / 100)
        )
        setInitialMute(
            newVal === 0 ? true : false
        )
    }


    const usePlayerRef = useRef(null)
    const BlockPlayerPlayRewind = (rewindEvent) => {
        usePlayerRef.current.seekTo(
            usePlayerRef.current.getCurrentTime() - 40
        )
    }
    const BlockPlayerPlayForward = (forwardEvent) => {
        usePlayerRef.current.seekTo(
            usePlayerRef.current.getCurrentTime() + 40
        )
    }

    const BlockPlayerScreenfull = (screenfullEvent) => {
        screenfull.request(findDOMNode(usePlayerRef.current))
    }

    const [ initialPlayed, setInitialPlayed ] = useState( played );
    const [ initialLoaded, setInitialLoaded ] = useState( loaded );
    const [ initialSeekingMouse, setInitialSeekingMouse ] = useState( false );
    const HandelProgress = ({loaded, loadedSeconds, played, playedSeconds}) => {
        if( !initialSeekingMouse ){
            setInitialPlayed(played)
        }
        setInitialLoaded(parseFloat(loaded * 100 ))
    }

    const OnSeekMouseDownBlockPlayer = (e) => {
        setInitialSeekingMouse(true)                                                                                                                 
    }           

    const OnSeekMouseUpBlockPlayer = (newVal) => {
        setInitialSeekingMouse(false)      
        // setInitialPlayed(parseFloat(newVal / 100))
        usePlayerRef.current.seekTo(
            parseFloat(newVal / 100)
        )                                                                                        
    }       

    const [ initialDuration, setInitialDuration ] = useState( duration );
    const OnDurationBlockPlayer = (duration) => {
        setInitialDuration((duration / 60).toFixed(2))                                                    
    }       

    const OnSeekBlockPlayer = (newVal) => {
        setInitialPlayed(parseFloat(newVal / 100))      
        setInitialDuration((duration / 60).toFixed(2))                                                                
    }  

    
    const [ initPlaybackRate, setPlaybackRate ] = useState( 1.0 );
    const handleSetPlaybackRate = (e) => {
        setPlaybackRate(
            parseFloat(e)
        );
    }

    const [ timeDisplayFormat, setTimeDisplayFormat ] = useState( 'normal' );
    const handleDisplayFormat = () => {
        setTimeDisplayFormat(
            timeDisplayFormat == "normal" ? "remaining" : "normal"
        );
    };

    const BlockPlayerRestarte = () => {
        setInitialPlayed(0) 
        setInitialDuration(0) 
        usePlayerRef.current.seekTo(0)   
    };

    const handleEndPlay = () => {
        setInitialPlayed(0) 
        setInitialDuration(0) 
        usePlayerRef.current.seekTo(0)   
        setInitialPlaying(!initialPlaying)
    };

                
    const [ initialPip, setInitialPip ] = useState( pip );
    const BlockPlayerPip = (pipEvent) => {
        setInitialPip(!initialPip)
    }
    const handleEnablePIP = () => {
        setInitialPip(
            true
        )
    }
    const handleDisablePIP = () => {
        setInitialPip(
            false
        )
    }
    
    
    
    const currentTime = usePlayerRef && usePlayerRef.current ? usePlayerRef.current.getCurrentTime() : "00:00";
    const durationTotalCount = usePlayerRef && usePlayerRef.current ? usePlayerRef.current.getDuration() : "00:00";
    // const elapsedTime = timeDisplayFormat == "normal" ? format(currentTime) : `-${format(durationTotal - currentTime)}`;
    const elapsedTime = format(currentTime);
    const timeWeHave =  `${format(durationTotalCount - currentTime)}`;
    const totalDuration = format(durationTotalCount);
    return (
        <div className='blockplayer-area'>
            {/* {elapsedTime}
            {'elapsedTime'}
            {timeWeHave}
            {'timeWeHave'}
            {totalDuration}
            {'totalDuration'} */}
            <div className='blockplayer-video-area' style={{ width: `${width}`, height: `${height}`, borderRadius: `${radius.top} ${radius.right} ${radius.bottom} ${radius.left} ` }}>
                { currentTime == '00:00' || currentTime == '0' || currentTime == null ? 
                    <div
                        className='blockplayer-video-poster'
                        style={{ backgroundImage: `url(${poster})` }}
                    >
                    </div>
                    :
                    ''
                }
                {
                    // bigplayctr ?
                    //     <div className='blockplayer-play-icon-overlay'
                    //         onClick={(e) => BigplayctrHide(e)}
                    //     >
                    //         {initialBigplayHide ?
                    //             <button>
                    //                 {/* {initialPlaying ?
                    //                     <BlockplayerPush
                    //                         viewBox="0 0 24 24"
                    //                     />
                    //                     :
                    //                     <BlockplayerPlay
                    //                         viewBox="0 0 24 24"
                    //                     />
                    //                 } */}
                    //                 {
                                        
                    //                     <BlockplayerPlay
                    //                         viewBox="0 0 24 24"
                    //                     />
                    //                 }
                    //             </button>
                    //             :
                    //             <>
                    //             </>
                    //         }
                    //     </div>
                    // : <></>
                }
                <ReactPlayer
                    ref={usePlayerRef}
                    className='blockplayer-video'
                    width='100%'
                    height='100%'
                    url={url}
                    pip={initialPip}
                    playing={initialPlaying}
                    muted={initialMute}
                    volume={initialVolume}
                    onProgress={HandelProgress}
                    onDuration={OnDurationBlockPlayer}
                    playbackRate={initPlaybackRate}
                    onEnablePIP={handleEnablePIP}
                    onDisablePIP={handleDisablePIP}
                    // onReady={() => console.log('onReady')}
                    // onStart={() => console.log('onStart')}
                    // onBuffer={() => console.log('onBuffer')}
                    // onSeek={e => console.log('onSeek', e)}
                    // onError={e => console.log('onError', e)}
                    // onPlay={this.handlePlay}
                    // onPause={this.handlePause}
                    onEnded={handleEndPlay}
                    // controls={controls}
                    // light={light}
                    loop={loop}
                />
                <BlockPlayerControls
                    initialBigplayHide={initialBigplayHide}
                    pipcontrols={pipcontrols}
                    bigplayctr={bigplayctr}
                    playcontrols={playcontrols}
                    restartcontrols={restartcontrols}
                    rewindcontrols={rewindcontrols}
                    forwardcontrols={forwardcontrols}
                    progresscontrols={progresscontrols}
                    mutecontrols={mutecontrols}
                    volumecontrols={volumecontrols}
                    fullscreencontrols={fullscreencontrols}
                    downloadcontrols={downloadcontrols}
                    initialPip={initialPip}
                    BlockPlayerPip={BlockPlayerPip}
                    initialPlaying={initialPlaying}
                    BlockPlayerPlayPause={BlockPlayerPlayPause}
                    BigplayctrHide={BigplayctrHide}
                    BlockPlayerPlayRewind={BlockPlayerPlayRewind}
                    BlockPlayerPlayForward={BlockPlayerPlayForward}
                    initialMute={initialMute}
                    BlockPlayerMute={BlockPlayerMute}
                    ReactPlayer={ReactPlayer}
                    url={url}
                    BlockPlayerScreenfull={BlockPlayerScreenfull}
                    initialPlayed={initialPlayed}
                    onSeekBlockPlayer={OnSeekBlockPlayer}
                    onSeekMouseDownBlockPlayer={OnSeekMouseDownBlockPlayer}
                    onSeekMouseUpBlockPlayer={OnSeekMouseUpBlockPlayer}
                    initialDuration={initialDuration}
                    onDurationBlockPlayer={OnDurationBlockPlayer}
                    elapsedTime={elapsedTime}
                    totalDuration={totalDuration}
                    timeWeHave={timeWeHave}
                    currentTime={currentTime}
                    handleDisplayFormat={handleDisplayFormat}
                    onChangeVolume={onChangeVolume}
                    initialVolume={initialVolume}
                    onChangeCommittedVolume={onChangeCommittedVolume}
                    handleSetPlaybackRate={handleSetPlaybackRate}
                    initPlaybackRate={initPlaybackRate}
                    initialLoaded={initialLoaded}
                    BlockPlayerRestarte={BlockPlayerRestarte}
                />
            </div>
            <small
                style={
                    {
                        display: `${devurl ? 'block' : 'none'}`
                    }
                }
            >
                <a href='https://gutenplayer.com/blockplayer/'>
                    Blockplayer - developed by gutenplayer
                </a>
            </small>
        </div>
	);
}